import React, { useState, useEffect, useRef, useMemo  } from "react";
import GrandAudio from "../../../assets/Grand.wav";
import { Link } from 'react-router-dom';
import axios from "axios";

const Rider = ({ order }) => {
  const [orderData, setOrderData] = useState([]);
  const [delBoyData, setDelBoyData] = useState([]);
  const audioRef = useRef(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null)
  const [selectedCustomerId, setSelectedCustomerId] = useState(null)
  const [selectedCustomerData, SetSelectedCustomerData] = useState([])
  const [customerLatitude, setCustomerLatitude] = useState(null);
  const [customerLongitude, setCustomerLongitude] = useState(null);
  const [deliveryAddressId,setDeliveryAddressId] = useState(null);
  
  const API_BASE_URL = process.env.REACT_APP_SERVER_API;
  
  localStorage.setItem("CustLat", customerLatitude);
  localStorage.setItem("CustLon", customerLongitude)

  // const googleMapsLink = `https://www.google.com/maps/dir/?api=1&destination=${customerLatitude},${customerLongitude}&travelmode=driving`;  

  const handleMobileNavigation = () => {
    const googleMapsAppLink = `google.navigation:q=${customerLatitude},${customerLongitude}&mode=d`;
    window.location.href = googleMapsAppLink; // Works on mobile devices
  };



  const address = useMemo(() => 
    selectedCustomerData?.addresses?.find(item => item.addressId == deliveryAddressId) || null, 
    [selectedCustomerData, order]
  );
 
useEffect(() => {
  if (selectedCustomerId) {
    SelectedCustomer();
  }
}, [selectedCustomerId]);


useEffect(() => {
  if (address) {
    setCustomerLatitude(address.latitude);
    setCustomerLongitude(address.longitude);
  } else {
    // Set default or clear coordinates if no address is found
    setCustomerLatitude(null);
    setCustomerLongitude(null);
  }
}, [address, setCustomerLatitude, setCustomerLongitude]);

// Instead of returning null when address is not found, handle gracefully:
const renderAddress = () => {
  if (!address) {
    return <p className="text-muted">Address not available</p>;
  }

}


  // Load order data on page load
  useEffect(() => {
    const storedOutletId = localStorage.getItem("outletId");
    if (storedOutletId) {
      const outletId = parseInt(storedOutletId, 10);

      // Call immediately on mount
      getOrderData(outletId);

      // Set interval to call every 15 seconds
      const intervalId = setInterval(() => {
        getOrderData(outletId);
      }, 10000);

      // Cleanup interval on unmount
      return () => clearInterval(intervalId);
    }
  }, []);

  


  // Play audio whenever orderData updates and has statusId = 1
  useEffect(() => {
    const statusOneCount = orderData.filter(
      (order) => order.onlineOrderStatusDetails?.[0]?.orderStatus == 3
    ).length;

    if (statusOneCount > 0) {
      playAudio();
    } else {
      stopAudio();
    }
  }, [orderData]);

  const LoginDeliveryById = localStorage.getItem("deliveryBoyId")

  // Function to get order data
  const getOrderData = async (outletId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/QrOrder/GetOrdersByOutletId`, {
        params: { outletId },
      });

      const filteredOrders = response.data.filter((order) =>
        order.deliveryDetail?.deliveryBoyId == LoginDeliveryById &&
      order.onlineOrderStatusDetails.some((detail) => detail.orderStatus >= 3 && detail.orderStatus <= 5) 
       
      );


     
      

      const delBoyResponse = await axios.get(`${API_BASE_URL}/DeliveryBoy/GetDeliveryBoyByOutletId`,
        { params: { outletId } }
      );

      setDelBoyData(delBoyResponse.data);
      setOrderData(filteredOrders);
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  // Audio functions
  const playAudio = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(GrandAudio);
      audioRef.current.loop = true; // Enable loop
    }

    audioRef.current.play().catch((error) => {
      console.log("Audio play error:", error);
    });
  };

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // Reset audio to start
    }
  };

  // Handle Accept button click
  const handleAcceptClick = async (orderId) => {
    try {
      // Find the order being updated
      const orderToUpdate = orderData.find(
        (item) => item.orderId === orderId
      );

      if (!orderToUpdate) {
        console.error("Order not found.");
        return;
      }

      // Get the current orderStatus and increment by 1
      const existingOrderStatus =
        orderToUpdate.onlineOrderStatusDetails?.[0]?.orderStatus || 0;

      const orderStatusData = {
        orderStatus: existingOrderStatus + 1,
      };

      // Call API to update order status
      const orderStatusResponse = await axios.put(`${API_BASE_URL}/QrOrder/${orderId}/status/0`,
        orderStatusData
      );

      if (orderStatusResponse) {
        console.log(`Order ${orderId} accepted.`);

        // Update local state to reflect the change
        const updatedOrders = orderData.map((order) =>
          order.orderId === orderId
            ? {
              ...order,
              onlineOrderStatusDetails: [
                {
                  ...order.onlineOrderStatusDetails[0],
                  orderStatus: existingOrderStatus + 1,
                },
              ],
            }
            : order
        );

        setOrderData(updatedOrders);

        // Stop audio when Accept button is clicked
        stopAudio();
      }
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  
  const SelectedCustomer = async () => {
    try {
      const CustomerResponse = await axios.get(`${API_BASE_URL}/CustomerMaster/${selectedCustomerId}`);
      SetSelectedCustomerData(CustomerResponse.data); 
    } catch (error) {
      console.log("Select Customer API Error", error);
    }
  };
  



  // Status mappings
  const statusMap = {
    1: "Placed",
    2: "Accepted",
    3: "Ready",
    4: "Pickup",
    5: "Delivered",
    6: "Paid"
  };

  const statusBtnMap = {
    1: "Accept",
    2: "Ready",
    3: "Pickup",
    4: "Delivered",
    5: "Paid"
  };

  const statusColors = {
    1: "#FAA0A0", // Pastel Red
    2: "#FDFD96", // Pastel Yellow
    3: "#779ECB", // Pastel Blue
    4: "#77DD77", // Pastel Green
  };

  return (
    <div className="container-fluid">
      <div className="col-md-12">
        <div className="row">
          {orderData.length > 0 ? (
            <div className="accordion" id="accordionExample">
              {orderData.map((order, index) => {
                const totalAmount = order.orderDetails.reduce(
                  (sum, item) => sum + item.amount,
                  0
                );

                return (
                  <div className="accordion-item" key={order.orderId || index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button collapsed mb-1"
                        style={{
                          border: "0.5px solid black",
                          backgroundColor:
                            statusColors[
                            order?.onlineOrderStatusDetails?.[0]?.orderStatus
                            ] || "white",
                        }}
                        type="button"
                        onClick={() =>{
                          setSelectedOrderId(order.orderId || null);
                          setSelectedCustomerId(order.customerId);
                          setDeliveryAddressId(order.deliveryAddress);
                          
                      }}
                      

                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}
                        aria-expanded="false"
                        aria-controls={`collapse${index}`}
                      >
                        <div className="container-fluid w-100 p-0">
                          <div className="row">
                            <div className="col-md-12 d-flex justify-content-between">
                              <p className="m-0">
                                <strong>Ord ID:</strong> {order.orderId}
                              </p>
                              <p className="m-0">
                                <strong>Status:</strong>{" "}
                                {statusMap[
                                  order.onlineOrderStatusDetails[0].orderStatus
                                ] || "Unknown"}
                              </p>
                            </div>
                            <div className="col-md-12 d-flex justify-content-between">
                              <p className="m-0">
                                <strong>Delivery Boy:</strong>{" "}
                                {order?.deliveryDetail?.deliveryBoyId
                                  ? delBoyData.find(
                                    (item) => String(item.deliveryBoyId) == String(order.deliveryDetail.deliveryBoyId) // Ensure type-safe comparison
                                  )?.deliveryBoyName || "Not Alloted"
                                  : "Not Alloted"}

                              </p>
                            </div>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${index}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="col-12 mt-2">
                        <h6>{selectedCustomerData.customerName || "Customer Name"}</h6>

                        
                        <div className="d-flex">
  {address ? (
    <h6>
      {address.addLine1}, <br />
      {address.addLine2}, {address.nearBy}, {address.area}<br />
      {address.city}<br />
      {address.state}: {address.pincode},<br />
      lat: {address.latitude} &nbsp; lon: {address.longitude}<br/>
      Distance:{order.distance} &nbsp; Time: {order.duration}<br/>
      {/* <Link className='btn btn-primary mt-2' to={googleMapsLink}>
      Open Route Map
        </Link> */}

        <button className="btn btn-primary mt-2" onClick={handleMobileNavigation}>
      🚗 Start Navigation
    </button>


    </h6>
  ) : (
    <p className="text-muted">Address not available</p>
  )}
</div>









                          <table className="table table-bordered">
                            <thead className="thead-light">
                              <tr>
                                <th>Code</th>
                                <th>Item Name</th>
                                <th>Rate</th>
                                <th>Qty</th>
                                <th>Amt</th>
                              </tr>
                            </thead>
                            <tbody>
                              {order.orderDetails.map((item, idx) => (
                                <tr key={idx}>
                                  <td>{item.rmsItemId}</td>
                                  <td>{item.qrItemName}</td>
                                  <td>{item.rate}</td>
                                  <td>{item.quantity}</td>
                                  <td>{item.amount}</td>
                                </tr>
                              ))}
                            </tbody>
                            {/* Total Amount Row */}
                            <tfoot>
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-end fw-bold"
                                >
                                  Total Amount:
                                </td>
                                <td className="fw-bold">{totalAmount}</td>
                              </tr>
                            </tfoot>
                          </table>
                          <div className="d-flex justify-content-end">

                            <button

                              className="btn btn-outline-success"
                              onClick={() => handleAcceptClick(order.orderId)}
                            >
                              {statusBtnMap[
                                order.onlineOrderStatusDetails[0].orderStatus
                              ] || "Unknown"}

                            </button>
                          </div>

                          
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p>No orders available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Rider;
;
